import * as React from 'react'
import { useDispatch } from 'react-redux'
import { Box } from '@mui/material'
import {
  setSelectedList,
  setFilterState,
  setFiltersUsed,
  setSearchByType,
  setTypeSearchUsed,
  setEnabledFilter,
  clearFilteredData,
} from '../../redux/slices/Search/input'
import { infoOptions } from '../../utils'
import { useFilterOptions } from '../../hooks/useFilterOptions'
import AutoCompleteItem from '../Autocomplete'

const MSJ = 'No se encuentraron registros, intente nuevamente o recarge la página.'

const SearchMain = ({ searchType, filterList1, width }) => {
  const dispatch = useDispatch()
  const options = useFilterOptions(searchType)
  const placeholder = infoOptions?.[searchType]?.name

  const handleSelection = (e, newList) => dispatch(setSelectedList(newList))

  const handleDeleteALL = async (event, value, reason) => {
    if (reason === 'clear') {
      try {
        dispatch(clearFilteredData())
        dispatch(setFilterState(true))
        dispatch(setFiltersUsed([]))
        dispatch(setSearchByType(''))
        dispatch(setTypeSearchUsed(''))
        dispatch(setEnabledFilter(false))
      } catch (err) {
        console.error('Error clearing basic search:', err)
        window.alert(MSJ)
      }
    }
  }

  if (!searchType || !options) return null

  return (
    <Box sx={{ width }}>
      <AutoCompleteItem
        sx={{ width: width }}
        multiple
        type={searchType}
        valueList={filterList1}
        onChange={handleSelection}
        options={options}
        onInputChange={handleDeleteALL}
        placeholder={placeholder}
      />
    </Box>
  )
}
export default SearchMain
